import { render } from "./search-filters-parent.vue?vue&type=template&id=005532f6"
import script from "./search-filters-parent.vue?vue&type=script&lang=js"
export * from "./search-filters-parent.vue?vue&type=script&lang=js"

import "./search-filters-parent.vue?vue&type=style&index=0&id=005532f6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__